import type { FormInputType, FormSelectOption } from '@multiplayer-app/ai-agent-types'

export const FormApplyRequestedEventType = 'mp:formApplyRequested' as const

export type ProposedFormFieldValue = {
  name: string
  label?: string
  value: string
  inputType?: FormInputType
  options?: FormSelectOption[]
}

export type FormApplyRequestedDetail = {
  chatId: string
  toolCallId: string
  formId: string
  formName?: string
  fields: ProposedFormFieldValue[]
}

export type FormApplyRequestedEvent = CustomEvent<FormApplyRequestedDetail>
